:host {
  position: relative;
  height: 100%;
  width: 100%;
  color: transparent;

  gz-link {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
